import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d1dd2b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-title _block_title" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "card-content default_text"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-button" }, " 查看更多 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScrollEnter = _resolveComponent("ScrollEnter")!

  return (_openBlock(), _createBlock(_component_ScrollEnter, {
    _inactive: _ctx._inactive,
    _thresholdVal: 0.1,
    _duration: 0.7,
    _thresholdType: "vh",
    class: "_block_container"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass({_wrap:true, fixSize:_ctx.fixSize}),
        onClick: _cache[0] || (_cache[0] = ()=>_ctx.onClickBox(_ctx.article))
      }, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.article.title.split("（2")[0].split("(")[0]), 1),
        _createElementVNode("img", {
          class: "image_floater",
          src: _ctx.injectOSS(_ctx.article.image),
          alt: "",
          style: {"width":"110px"}
        }, null, 8, _hoisted_2),
        (_ctx.article.abstract)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString((_ctx.article.abstract.slice(0,100) + (_ctx.article.abstract.length>100?'...':'' )).replaceAll(/&nb/g, 'nb').replaceAll(/nbsp/g, '')), 1))
          : _createCommentVNode("", true),
        _hoisted_4
      ], 2)
    ]),
    _: 1
  }, 8, ["_inactive", "_thresholdVal", "_duration"]))
}